import { useQuery } from '@tanstack/react-query';
import { publicReportClient } from 'api';
import type { ApiError, PublicOrderCustomForm } from 'common/models';

import type { PublicCustomFormReportContent } from './models';

const publicReportKey = 'publicReport';

export const getPublicReportQueryKeyBuilder = (
  customFormId: string,
  reportId: string,
  serviceObjectId?: string
) => [publicReportKey, customFormId, reportId, serviceObjectId];

export const useGetPublicReportQuery_old = (
  tenantCode: string,
  customerId: string,
  orderCustomFormId: string
) => {
  return useQuery<PublicOrderCustomForm, ApiError>([publicReportKey], () =>
    publicReportClient.getPublicReport_old(tenantCode, customerId, orderCustomFormId)
  );
};

export const useGetPublicReportQuery = (
  tenantCode: string,
  customerId: string,
  orderCustomFormId: string,
  reportId: string,
  serviceObjectId?: string
) => {
  return useQuery<PublicCustomFormReportContent, ApiError>(
    getPublicReportQueryKeyBuilder(orderCustomFormId, reportId, serviceObjectId),
    () =>
      publicReportClient.getPublicReport(
        tenantCode,
        customerId,
        orderCustomFormId,
        reportId,
        serviceObjectId
      ),
    {
      refetchOnWindowFocus: false
    }
  );
};
